import { Component } from 'react';
import { connect } from 'react-redux';



class Sizing extends Component {
  constructor(props) {
    super(props);
    // this.state = { windowWidth: 768, windowHeight: 1024 };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    const windowSize = { width: window.innerWidth, height: window.innerHeight }
    const windowAspect = windowSize.width / windowSize.height;
    const windowLandscape = windowAspect > 1;
    const landscapeGroupSizing = { height: `${windowSize.height * 0.85}px` }
    const portraitGroupSizing = { width: `${windowSize.width * 0.85}px` }
    const imageMaximums = { maxWidth: `${windowSize.width * 0.80}px`, maxHeight: `${windowSize.height * 0.80}px` }

    if (windowLandscape) {
      document.body.style = { overflowY: 'hidden', overflowX: 'auto' };
    } else {
      document.body.style = { overflowX: 'hidden', overflowY: 'auto' };
    }

    const headerHeight = windowSize.height * 0.07;
    const footerSpace = windowSize.height * 0.01;
    const footerHeight = windowSize.height * 0.10;

    this.props.setState({
      windowSize,
      windowAspect,
      windowLandscape,
      groupSizingStyle: windowLandscape ? landscapeGroupSizing : portraitGroupSizing,
      imageMaximums,
      headerHeight,
      footerHeight,
      footerSpace,
    })

    // this.props.updateWindowDimensions(window.innerWidth, window.innerHeight);
    // this.setState({ windowWidth: window.innerWidth, windowHeight: window.innerHeight });
  }

  widthForHeightMatch() {
    return this.props.target.width * this.state.windowHeight / this.props.target.height;
  }

  heightForWidthMatch() {
    return this.props.target.height * this.state.windowWidth / this.props.target.width;
  }

  willMatchingWidthFit() {
    // calculate the height of the image if scaled so that image width matches window width
    return this.props.target && (this.heightForWidthMatch() < this.state.windowHeight);
  }

  render() {
    return this.props.children; // is this even needed?  
  }
}

const mapStateToProps = (state) => state.sizing

const mapDispatchToProps = (dispatch) => ({
  setState: (updates) => dispatch({ type: "UPDATE", sizing: updates })
})

export default connect(mapStateToProps, mapDispatchToProps)(Sizing);




// WEBPACK FOOTER //
// ./src/Sizing.js